module.exports = __webpack_public_path__ + "static/media/View_detail.855d129b.svg";